import { WA_MESSAGES } from "@/lib/whatsapp";

// Approved marketing copy sourced from the Voltech Digital Marketing Playbook 2026.

export const TRUST_BAR = [
  "GST-Verified Manufacturer",
  "5-Year Battery Warranty",
  "Established 2020, Hyderabad",
  "Real-Time Monitoring via voltech.live",
  "Pan-India Delivery in 5 Days",
  "Custom Orders from 1 Unit",
];

export const WHY_CHOOSE = [
  {
    title: "In-house manufacturer, not a reseller",
    body: "Factory-direct pricing with no middleman markup.",
  },
  {
    title: "voltech.live monitoring included",
    body: "Every battery connects to our real-time dashboard.",
  },
  {
    title: "Custom-built in 10 working days",
    body: "Tell us your specs — we engineer and deliver.",
  },
  {
    title: "5-year warranty on all batteries",
    body: "Backed by the team that built your battery.",
  },
  {
    title: "WhatsApp-first support",
    body: "Real responses from our engineers, not a chatbot.",
  },
];

export const VOLTECH_LIVE = {
  name: "voltech.live",
  url: "https://voltech.live",
  tagline: "Real-time battery intelligence",
  description:
    "Our proprietary voltech.live platform lets you monitor battery health, voltage, temperature and charge cycles in real time — from any device, anywhere. Included free with every Voltech battery.",
  metrics: ["Voltage & current", "Temperature", "State of charge", "Cycle count"],
};

// Homepage product cards
export const PRODUCT_CARDS = [
  {
    name: "LFP Inverter Batteries",
    description:
      "Replace your lead-acid battery once, for life. 10+ year lifespan, zero maintenance.",
    button: "Shop Now",
    to: "/lfp-inverter-batteries",
  },
  {
    name: "Solar Street Lights",
    description:
      "All-in-one commercial-grade lights with our own LFP batteries inside. 12W to 120W.",
    button: "Get Quote",
    to: "/solar-street-lights",
  },
  {
    name: "Custom Battery Packs",
    description:
      "OEM, EV, industrial. Any voltage, any capacity. Transparent pricing, fast turnaround.",
    button: "Configure Now",
    to: "/custom-battery-packs",
  },
  {
    name: "Solar Inverters",
    description: "Hybrid, grid-tied, and off-grid. Solar-ready from Day 1.",
    button: "Explore",
    to: "/products",
  },
  {
    name: "EV Batteries",
    description:
      "2-wheeler, 3-wheeler, and fleet packs. Tested for Indian road conditions.",
    button: "Inquire",
    to: "/products",
  },
  {
    name: "Battery Service & AMC",
    description: "Health checks, repair, and annual maintenance contracts.",
    button: "Book Service",
    to: "/contact",
  },
];

// ---- Landing page configs ----
export const LANDING_PAGES = {
  "lfp-inverter-batteries": {
    key: "lfp",
    seoTitle: "LFP Inverter Batteries",
    seoDescription:
      "Voltech LFP inverter batteries last 10+ years vs 2–3 for lead-acid. Drop-in replacement, zero maintenance, 5-year warranty, free voltech.live monitoring. Hyderabad manufacturer.",
    eyebrow: "LFP Inverter Batteries",
    heroHeadline: "Replace your lead-acid battery once. For life.",
    heroSub:
      "Our LFP batteries last 10+ years vs 2–3 years for lead-acid. One replacement today saves you ₹30,000–50,000 over the next decade.",
    heroImage:
      "https://images.unsplash.com/photo-1742899273038-67ff67477663?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxsaXRoaXVtJTIwYmF0dGVyeSUyMGluZHVzdHJpYWx8ZW58MHx8fHwxNzgxNzcwMzM3fDA&ixlib=rb-4.1.0&q=85",
    ctaText: "Order on WhatsApp — Get Today's Price",
    waMessage: WA_MESSAGES.lfp,
    comparison: {
      title: "LFP vs Lead-Acid — 10-year cost",
      cols: ["Feature", "Lead-Acid", "Voltech LFP"],
      rows: [
        ["Lifespan", "2–3 years", "10+ years"],
        ["Replacements in 10 years", "4–5 times", "1 time"],
        ["Total 10-year cost", "₹40,000–60,000", "₹12,000–25,000"],
        ["Weight", "15–20 kg", "6–9 kg"],
        ["Maintenance", "Monthly water topping", "Zero maintenance"],
        ["Remote monitoring", "Not available", "Free via voltech.live"],
      ],
    },
    range: {
      title: "Product range",
      cols: ["Model", "Voltage / Capacity", "Ideal for", "Warranty"],
      rows: [
        ["VT-12-100", "12V 100Ah LFP", "600VA–1 kVA inverters", "5 years"],
        ["VT-24-100", "24V 100Ah LFP", "1.5–2 kVA inverters", "5 years"],
        ["VT-48-100", "48V 100Ah LFP", "3–5 kVA systems", "5 years"],
        ["VT-CUSTOM", "Any voltage, any Ah", "As per your inverter", "5 years"],
      ],
      note: "WhatsApp us for today's pricing on any model.",
    },
    faqs: [
      {
        q: "Will this fit my existing inverter?",
        a: "Yes — our LFP batteries are drop-in replacements for lead-acid. They work with all major inverter brands. Send us your inverter model on WhatsApp and we'll confirm compatibility in minutes.",
      },
      {
        q: "How is LFP different from other lithium batteries?",
        a: "LFP (Lithium Iron Phosphate) is the safest chemistry for home use — no fire risk, no toxic gases. It's the same chemistry used in grid-scale energy storage globally. We don't use NMC or NCA chemistry for home inverter batteries.",
      },
      {
        q: "Can I monitor my battery health remotely?",
        a: "Yes. Every Voltech battery can be connected to our voltech.live dashboard — showing real-time voltage, temperature, state of charge, and cycle count from your phone, anywhere.",
      },
    ],
  },

  "solar-street-lights": {
    key: "solar",
    seoTitle: "Solar Street Lights",
    seoDescription:
      "Commercial-grade all-in-one solar street lights 12W–120W with in-house LFP batteries. Bulk pricing for RWAs, factories, panchayats & highways. 5-year battery warranty. Pan-India delivery.",
    eyebrow: "Solar Street Lights",
    heroHeadline: "Light up your colony, factory or road — zero electricity bill",
    heroSub:
      "Commercial-grade all-in-one solar street lights with our own LFP batteries inside. We manufacture the light AND the battery — no middleman, better quality, lower price.",
    heroImage:
      "https://images.pexels.com/photos/29294301/pexels-photo-29294301.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ctaText: "Get bulk pricing on WhatsApp",
    waMessage: WA_MESSAGES.solar,
    range: {
      title: "Product range & pricing",
      cols: ["Model", "Wattage", "Best for", "Price / unit", "MOQ"],
      rows: [
        ["VSL-12", "12W", "Garden paths, walkways", "₹3,500+", "5 units"],
        ["VSL-20", "20W", "Colony streets, parking lots", "₹4,800+", "5 units"],
        ["VSL-40", "40W", "Main roads, gram panchayat", "₹8,500+", "10 units"],
        ["VSL-80", "80W", "Commercial/industrial roads", "₹19,000+", "5 units"],
        ["VSL-120", "120W", "Highways, large complexes", "₹32,000+", "3 units"],
      ],
      note: "Prices include LFP battery, solar panel, LED chip, motion sensor and controller. Poles and installation available on request.",
    },
    bundle: {
      title: "Complete installation bundle",
      body: "Light + pole arm + concrete anchor kit + commissioning guide + 1-year service SLA — shipped to your site anywhere in India.",
    },
    whoBuys: {
      title: "Who buys from us",
      items: [
        "Housing societies (RWAs)",
        "Factories and warehouses",
        "Gram panchayats and small municipalities",
        "Highway contractors",
        "Educational institutions",
      ],
    },
    faqs: [
      {
        q: "Do your solar street lights use LFP or lead-acid batteries?",
        a: "All Voltech solar street lights use LFP (Lithium Iron Phosphate) batteries. LFP batteries last 8–10 years, whereas lead-acid typically fails within 2–3 years — so your lights run reliably for far longer, saving replacement and maintenance costs.",
      },
      {
        q: "What is the warranty on your solar street lights?",
        a: "We offer a 5-year warranty on the LFP battery and a 3-year warranty on the LED chip and other electrical components.",
      },
      {
        q: "Can you provide lights for large projects like highways or industrial areas?",
        a: "Absolutely. We offer solar street lights up to 120W, suitable for highways and large industrial areas, plus custom solutions and efficient bulk-order handling.",
      },
    ],
  },

  "custom-battery-packs": {
    key: "custom",
    seoTitle: "Custom Battery Packs",
    seoDescription:
      "Custom lithium battery packs built in Hyderabad — 12V to 96V, 5Ah to 300Ah, LFP or NMC. Transparent pricing from ₹5,500. 5–10 day delivery. EV, OEM & industrial. 5-year warranty.",
    eyebrow: "Custom Battery Packs",
    heroHeadline: "Tell us your specs. We build your battery.",
    heroSub:
      "From e-rickshaw packs to medical device batteries to industrial energy storage — we design and manufacture custom lithium battery packs at our Hyderabad facility. Factory-direct pricing. 10-day delivery.",
    heroImage:
      "https://images.unsplash.com/photo-1633899306328-c5e70574aaa2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0MzgyOTV8MHwxfHNlYXJjaHwxfHxjdXN0b20lMjBiYXR0ZXJ5JTIwcGFja3xlbnwwfHx8fDE3ODE3NzAzMzd8MA&ixlib=rb-4.1.0&q=85",
    ctaText: "Send your specs on WhatsApp",
    waMessage: WA_MESSAGES.custom,
    pricing: {
      title: "Transparent pricing — standard configurations",
      cols: ["Configuration", "Capacity", "1 unit", "10+", "50+", "Lead time"],
      rows: [
        ["24V 20Ah LFP", "480 Wh", "₹5,500", "₹4,800", "₹4,200", "5 days"],
        ["48V 30Ah LFP", "1.44 kWh", "₹12,500", "₹11,000", "₹9,500", "5 days"],
        ["48V 60Ah LFP", "2.88 kWh", "₹22,000", "₹19,500", "₹17,000", "7 days"],
        ["60V 32Ah LFP", "1.92 kWh", "₹16,500", "₹14,500", "₹12,500", "5 days"],
        ["72V 40Ah LFP", "2.88 kWh", "₹24,000", "₹21,000", "₹18,500", "7 days"],
      ],
      note: "Prices indicative. Final price depends on BMS specs, connector type and form factor. GST extra.",
    },
    capabilities: {
      title: "Custom design capabilities",
      items: [
        ["Voltage", "12V to 96V (any configuration)"],
        ["Capacity", "5Ah to 300Ah"],
        ["Chemistry", "LFP (safe, long cycle life) or NMC (high energy density)"],
        ["Form factor", "Any shape for your enclosure"],
        ["BMS", "Custom thresholds, protocols (CAN, RS485, UART)"],
        ["Connector", "XT60, Anderson, or custom"],
      ],
    },
    process: {
      title: "How it works",
      steps: [
        "Send specifications via WhatsApp or enquiry form",
        "Receive a detailed quote within 24 hours",
        "Optional free 20-minute technical consultation with our engineer",
        "Pay 50% advance — production begins",
        "Delivered in 5–10 working days with test report and datasheet",
      ],
    },
    faqs: [
      {
        q: "Can you build custom battery packs for EVs (2 & 3-wheelers)?",
        a: "Yes — we specialize in custom EV packs for 2-wheelers, 3-wheelers and fleet vehicles, designed to your voltage, capacity and power needs with a robust BMS for safety and longevity.",
      },
      {
        q: "What is the lead time for custom orders?",
        a: "Standard configurations typically ship in 5–7 working days. Highly custom designs may take up to 10 working days after the 50% advance. Each quote includes an accurate lead time.",
      },
      {
        q: "Do you offer a warranty on custom battery packs?",
        a: "Yes — all custom packs carry a 5-year warranty, backed by our in-house manufacturing and quality control.",
      },
    ],
  },
};
